import {observer} from "mobx-react";
import {DialogStore, fmsPackageDetailStore, growlStore, validationStore} from "../../../store";
import {FmsReceiverForm} from "./FmsReceiverForm";
import {fmsReceiverStore} from "../../../store/fms/FmsReceiverStore";

interface FmsModalDialogReceiverProps {
    store: DialogStore
}


const FmsModalDialogReceiver = observer(function FmsModalDialogReceiver({
                                                                            store,
                                                                        }: FmsModalDialogReceiverProps) {
    return <>
        {store.dialogOpen && <div className={`modal is-active`}>
            <div className="modal-background" onClick={() => {
            }}></div>
            <div className="modal-content" style={{
                width: '60%'
            }}>
                <div className="modal-card" style={{
                    height: '100%',
                    width: '100%'
                }}>
                    <header className="modal-card-head">
                        <div className="modal-card-title">
                            Empfänger bearbeiten
                        </div>
                    </header>
                    <section className="modal-card-body" style={{
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            flex: '1'
                        }}>
                            <FmsReceiverForm
                                data={fmsReceiverStore.formData}
                                onChange={data => fmsReceiverStore.formData = data}
                                disabled={fmsReceiverStore.executing}
                                onBlur={() => fmsReceiverStore.validate()}
                                help={{
                                    city: validationStore.getFor('receiver.address.city'),
                                    addition: validationStore.getFor('receiver.address.addition'),
                                    country: validationStore.getFor('receiver.address.country'),
                                    houseNumber: validationStore.getFor('receiver.address.houseNumber'),
                                    postCode: validationStore.getFor('receiver.address.postCode'),
                                    street: validationStore.getFor('receiver.address.street'),
                                    line1: validationStore.getFor('receiver.line1'),
                                    line2: validationStore.getFor('receiver.line2'),
                                    mail: validationStore.getFor('receiver.mail'),
                                    phone: validationStore.getFor('receiver.phone'),
                                }}
                            />

                        </div>
                    </section>
                    <footer className={"modal-card-foot"}>
                        <div>
                            <button
                                className={"button is-rounded is-small"}
                                disabled={fmsReceiverStore.executing}
                                onClick={async () => {
                                    store.dialogOpen = false
                                    fmsReceiverStore.reset(false)
                                }
                                }
                            >Verwerfen
                            </button>
                            <button
                                className={"button is-primary is-rounded is-small"}
                                style={{
                                    marginLeft: '1em'
                                }}
                                disabled={!fmsReceiverStore.valid}
                                onClick={async () => {
                                    const success = await fmsReceiverStore.update()
                                    if (success) {
                                        growlStore.add({
                                            closable: true,
                                            autoclose: true,
                                            message: "Änderung des Empfängers erfolgreich"
                                        })
                                        store.dialogOpen = false
                                        fmsPackageDetailStore.reload()
                                    }
                                }}
                            >Speichern
                            </button>
                        </div>
                    </footer>
                </div>
            </div>
        </div>}
    </>
})

export {
    FmsModalDialogReceiver
}
